import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionCyberData.css';

const IntroSectionCyberAudit3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Cyber Audit
  const cyberAuditStats = [
    {
      value: '100%',
      label: 'Tests de pénétration',
      translationKey: 'auditCyber.stats.penetration',
      labelTranslationKey: 'auditCyber.stats.penetrationLabel'
    },
    {
      value: '24h',
      label: 'Réponse aux incidents',
      translationKey: 'auditCyber.stats.response',
      labelTranslationKey: 'auditCyber.stats.responseLabel'
    },
    {
      value: '99.9%',
      label: 'Détection menaces',
      translationKey: 'auditCyber.stats.detection',
      labelTranslationKey: 'auditCyber.stats.detectionLabel'
    },
    {
      value: '∞',
      label: 'Surveillance continue',
      translationKey: 'auditCyber.stats.monitoring',
      labelTranslationKey: 'auditCyber.stats.monitoringLabel'
    }
  ];

  return (
    <div className="intro-section-home intro-section-cyber-audit">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('auditCyber.introSection.commitment', 'Notre engagement')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        title="Une sécurité informée et proactive pour votre entreprise."
        subtitle="Nous identifions vos vulnérabilités avant qu'elles ne deviennent des menaces et vous accompagnons vers une cybersécurité robuste."
        titleTranslationKey="auditCyber.stats.title"
        subtitleTranslationKey="auditCyber.stats.subtitle"
        stats={cyberAuditStats}
        showChart={false}
      />
    </div>
  );
};

export default IntroSectionCyberAudit3;
